<template>
    <el-aside width="100%">
        <el-input  
            placeholder="输入房间号进行搜索"
            v-model="filterText"
            clearable
        >
        </el-input>
        

        <!-- <el-tree
            class="filter-tree"
            :data="tableData"
            :props="{ label: 'name' }"
            default-expand-all
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            ref="tree">
        </el-tree> -->

        <el-tree
            :data="tableData"
            :props="{ label: 'name' }"
            accordion
            node-key="id"
            :filter-node-method="filterNode"
			:default-expanded-keys="permTreeIds"
            @node-click="handleNodeClick"
            ref="tree"
            :render-content="renderContent"
        > 
        </el-tree>
    </el-aside>
</template>

<script>
import { getTree } from '@/apis/orange'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'LocationTree',
    data() {
        return {
            permTreeIds: [1,2,3,4], // 默认值为int
            filterText: '',
        }
    },
    computed: {
        ...mapState('treeData', ['isLoading']),
        ...mapGetters('treeData', ['treeData', 'hasData']),
        tableData: {
            get() {
                return this.treeData
            },
            set(value) {
                // 如果需要本地修改数据，可以在这里处理
            }
        }
    },
    created() {
        this.initTreeData()
    },
    beforeDestroy() {
        // 组件销毁时移除监听器
        this.$store.dispatch('treeData/unregisterUpdateListener', this.handleTreeDataUpdate)
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    methods: {
        ...mapActions('treeData', [
            'fetchTreeData',
            'refreshTreeData',
            'registerUpdateListener',
            'unregisterUpdateListener'
        ]),

        hasAuth(perm) {
			var authority = this.$store.state.menus.permList

			return authority.indexOf(perm) > -1
		},
        
        async initTreeData() {
            try {
                // 注册更新监听器
                this.registerUpdateListener(this.handleTreeDataUpdate)
                
                // 获取数据
                await this.fetchTreeData()
            } catch (error) {
                console.error('初始化树形数据失败:', error)
            }
        },
        
        // 处理树形数据更新
        handleTreeDataUpdate(newData) {
            // 当store中的数据更新时，这里会被调用
            // 可以在这里执行一些本地更新逻辑
            // console.log('树形数据已更新:', newData)
        },
        
        // 手动刷新数据
        async refreshData() {
            try {
                await this.refreshTreeData()
            } catch (error) {
                // console.error('刷新数据失败:', error)
            }
        },
        
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        handleNodeClick(data) {
            this.$emit('getTreeData', data);
        },
        renderContent(h, { node, data, store }) {
            // 默认内容
            const children = [
                h('span', [data.name])
            ];
            // 判断名称
            if ((data.name === '南区' || data.name === '北区')&& this.hasAuth('base:room:save')) {
                // 
                children.push(
                    h('el-button', {
                        props: {
                            type: 'text',
                            icon: 'el-icon-plus',
                            size: 'mini'
                        },
                        attrs: {
                            title: '新增楼栋'
                        },
                        style: { marginLeft: '8px' },
                        on: {
                            click: (event) => {
                                event.stopPropagation();
                                this.$emit('addNode', data);
                            }
                        }
                    })
                );
            }
            // 如果父节点是南区或北区，显示修改和删除按钮
            if (node.parent && (node.parent.data.name === '南区' || node.parent.data.name === '北区') && this.hasAuth('base:room:save')) {
                children.push(
                    h('el-button', {
                        props: {
                            type: 'text',
                            icon: 'el-icon-plus',
                            size: 'mini'
                        },
                        attrs: {
                            title: '新增房间'
                        },
                        style: { marginLeft: '8px' },
                        on: {
                            click: (event) => {
                                event.stopPropagation();
                                this.$emit('addRoom', data);
                            }
                        }
                    }),
                    h('el-button', {
                        props: {
                            type: 'text',
                            icon: 'el-icon-edit',
                            size: 'mini'
                        },
                        attrs: {
                            title: '修改楼栋'
                        },
                        style: { marginLeft: '8px', color: 'orange' },
                        on: {
                            click: (event) => {
                                event.stopPropagation();
                                this.$emit('editNode', data);
                            }
                        }
                    }),
                    h('el-button', {
                        props: {
                            type: 'text',
                            icon: 'el-icon-delete',
                            size: 'mini'
                        },
                        attrs: {
                            title: '删除楼栋'
                        },
                        style: { marginLeft: '4px', color: 'red' },
                        on: {
                            click: (event) => {
                                event.stopPropagation();
                                this.$emit('deleteNode', data);
                            }
                        }
                    })
                );
            }
            
            if ( (node.data.name == '楼层') && this.hasAuth('base:room:save')) {
                children.push(
                    h('el-button', {
                        props: {
                            type: 'text',
                            icon: 'el-icon-plus',
                            size: 'mini'
                        },
                        attrs: {
                            title: '新增房间'
                        },
                        style: { marginLeft: '8px' },
                        on: {
                            click: (event) => {
                                event.stopPropagation();
                                this.$emit('addRoom', data);
                            }
                        }
                    })
                );
            }
            return h('span', children);
        }
    }
} 
</script>

<style scoped >
	
</style>